import React, { useState } from 'react';
import ChatBot from '../../components/ChatBot/ChatBot';
import '../../styles/pages/ItineraryPage/ChatBotItinerarySection.css';

const ChatBotItinerarySection = ({ origin_id, itinerary_id, onOpenPreferences, toggleMapVisibility, isMapVisible }) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <div className="chatbot-itinerary-section">
      {isOpen && (
        <ChatBot
          onOpenPreferences={onOpenPreferences || (() => {})}
          toggleMapVisibility={toggleMapVisibility}
          isMapVisible={isMapVisible}
          suggestionEndpoint="/itinerary/suggestions"
          title="Itinerary Assistant"
          titleSectionText="Plan Your Adventure"
          useItineraryContext={true}
          origin_id={origin_id}
          itinerary_id={itinerary_id}
        />
      )}
    </div>
  );
};

export default ChatBotItinerarySection;
